var __jsx = React.createElement;
import React from "react";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import Styles from "./Styles.module.scss";
import Submit from "../Submit";
import DrawerLink from "../DatabaseDrawer/DrawerLink";
import Add from "./Add";
import AddDateRange from "./DateRange";
function Options(_ref) {
  var onAdd = _ref.onAdd,
    toggleYearRow = _ref.toggleYearRow,
    toggleYearState = _ref.toggleYearState;
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    className: "".concat(Styles.options, " ev-search-options-container")
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    className: Styles.options
  }, /*#__PURE__*/React.createElement(Add, {
    onClick: onAdd
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true
  }, /*#__PURE__*/React.createElement(AddDateRange, {
    toggleYearState: toggleYearState,
    onClick: toggleYearRow
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true
  }, /*#__PURE__*/React.createElement(DrawerLink, {
    className: "".concat(Styles.button, " es-link__black--16-font--text-underline")
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true
  }, /*#__PURE__*/React.createElement(Submit, {
    id: "submitSearchButton",
    name: "submit_search"
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }));
}
Options.defaultProps = {
  onSubmit: function onSubmit() {},
  disableSubmit: false
};
export default Options;